import { FontIcon } from "@fluentui/react";
import { contactListStyles as styles } from "../components/CustomerView/ContactList.styles";

export const ContactActions = ({ email }: { email?: string }) => {
  return (
    <div className={styles.contactInfo}>
      {email ? (
        <>
          <a href={`https://teams.microsoft.com/l/chat/0/0?users=${email}`} target="_blank" rel="noreferrer">
            <FontIcon aria-label="Teams" title="Send Teams Message" className={styles.iconCss} iconName="TeamsLogo" />
          </a>
          <a href={`mailto:${email}`}>
            <FontIcon aria-label="Outlook" title="Send An Email" className={styles.iconCss} iconName="Mail" />
          </a>
        </>
      ) : (
        <>
          <FontIcon
            aria-label="Teams"
            title="Teams Message Unavailable"
            className={styles.iconCss}
            iconName="TeamsLogo"
            style={{ opacity: 0.5, cursor: "not-allowed" }}
          />
          <FontIcon
            aria-label="Outlook"
            title="Email Unavailable"
            className={styles.iconCss}
            iconName="Mail"
            style={{ opacity: 0.5, cursor: "not-allowed" }}
          />
        </>
      )}
    </div>
  );
};
